import DashboardHeader from './common/dashboardHeader.js';
import DashboardContentLegacy from './dashboardContentLegacy.js';
import {Grid} from '@material-ui/core';


function DashboardLegacy(props){
    return(
        <Grid container xs="12" md="12" direction="row">
            <DashboardHeader Briefs={props.Briefs}/>
            <DashboardContentLegacy Briefs={props.Briefs}/>           
        </Grid>
    );

}

export default DashboardLegacy;